import { apiSlice } from './apiSlice'

/**
 * Long-Short dashboard data — `GET /api/v1/dashboard/long-short`.
 *
 * Mirrors FastAPI `LongShortDashboardResponse` (camelCase aliases). BE returns
 * DATA ROWS only; column/format config lives in `pages/dashboard/longShort/`.
 * Source: Report DB (`DATABASE_URL_REPORT`). Spec: plan/LongShort_Dashboard_BE_Proposal.md.
 *
 * No date params: the PBI page has no date slicer — the source views are
 * point-in-time (months before the current one pre-aggregated into "<YYYY-M").
 */

/** One matrix row. `values[monthCate][measureKey]` — missing bucket/measure = blank cell. */
export interface LongShortRow {
  category: string
  code: string | null
  rowType: 'category' | 'code' | 'total'
  values: Record<string, Record<string, number | null>>
}

export interface LongShortDashboardResponse {
  /** PBI report_date card — ISO `YYYY-MM-DD`. */
  reportDate: string | null
  /** Ordered month buckets ("<2026-6", "2026-6", …) → dynamic top-tier header. */
  monthCates: string[]
  /** Level 1 — "Gross Long-Short (Kg)": purchase, sale, monthlyPs, cumulative. */
  gross: LongShortRow[]
  /** Level 2 — "Net Long-Short (Kg)": stock, unallocPurchase, unallocSale,
   *  allocUnship, shipped, netMonthlyPs, cumulative. */
  net: LongShortRow[]
}

const dashboardLongShortApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLongShortDashboard: builder.query<LongShortDashboardResponse, void>({
      query: () => ({ url: '/dashboard/long-short' }),
    }),
  }),
})

export const { useGetLongShortDashboardQuery } = dashboardLongShortApi
